import React from 'react'
import TokenIcon from 'src/common/ui-kit/TokenIcon/TokenIcon'
import { AnyToken } from 'src/common/types/models/Tokens'
import ExplorerLink from '../Link/ExplorerLink'
import { PriceFeedData } from 'src/common/api-clients/swarm/types'
import { displayUsdAmount } from 'src/common/utils/formatters/number'

interface TokenInfoHeaderProps {
  token: AnyToken
  priceFeed?: PriceFeedData
}

const TokenInfoHeader: React.FC<TokenInfoHeaderProps> = ({
  token,
  priceFeed,
}) => {
  const price = priceFeed?.price
    ? `$${displayUsdAmount(priceFeed.price)}`
    : '--'

  return (
    <div className='flex flex-col items-center'>
      <TokenIcon className='mb-3' token={token} size={70} />
      <span className='text-primary text-body3 font-bold'>{token.name}</span>
      <span className='text-primary text-body3 font-bold'>{token.symbol}</span>
      <ExplorerLink
        className='text-primary group hover:underline'
        iconClassName='fill-main-accent'
        hash={token.contractAddress}
        type='token'
      />

      <span className='mt-4 text-body2 font-bold'>{price}</span>
    </div>
  )
}

export default TokenInfoHeader
